import { useEffect, useRef, useState } from "react";

import GuestImg from "../../assets/images/conversations/ep-54-pratik-gupta-guest.webp";
import ThumbImg from "../../assets/images/conversations/054.webp";
import PlayIcon  from "../../assets/icons/conversations/play-icon.svg";

/* ─────────────────────────────────────────────
   PREFIX: pt-
───────────────────────────────────────────── */
const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700;800&family=Roboto:wght@400;500&display=swap');

  *, *::before, *::after { margin: 0; padding: 0; box-sizing: border-box; }

  .pt-page {
    background: #1A1A1A;
    min-height: 100vh;
    font-family: 'Roboto', sans-serif;
    color: #fff;
  }

  .pt-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding-left: 102px;
    padding-right: 102px;
  }

  /* ══════════════════════════════════════
     SECTION 1 — HERO
  ══════════════════════════════════════ */
  .pt-hero {
    padding-top: 60px;
    padding-bottom: 60px;
  }
  .pt-hero__grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 30px;
    align-items: start;
  }
  .pt-hero__left {
    display: flex;
    flex-direction: column;
    gap: 44px;
  }
  .pt-hero__title {
    font-family: 'Montserrat', sans-serif;
    font-size: 32px;
    font-weight: 700;
    color: #ffffff;
    line-height: 140%;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .pt-hero__title.pt-visible {
    opacity: 1;
    transform: translateY(0);
  }
  .pt-hero__spotify {
    border-radius: 12px;
    overflow: hidden;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.18s, transform 0.7s ease 0.18s;
  }
  .pt-hero__spotify.pt-visible {
    opacity: 1;
    transform: translateY(0);
  }
  .pt-hero__spotify iframe {
    display: block;
    width: 100%;
    height: 152px;
    border: none;
    border-radius: 12px;
  }
  .pt-hero__right {
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.1s, transform 0.7s ease 0.1s;
  }
  .pt-hero__right.pt-visible {
    opacity: 1;
    transform: translateY(0);
  }

  /* thumbnail */
  .pt-yt-thumb {
    position: relative;
    width: 100%;
    border-radius: 12px;
    overflow: hidden;
    cursor: pointer;
    display: block;
    background: #000;
  }
  .pt-yt-thumb img {
    width: 100%;
    height: auto;
    display: block;
    border-radius: 12px;
    transition: opacity 0.3s ease;
  }
  .pt-yt-thumb:hover img { opacity: 0.85; }
  .pt-yt-thumb__play {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: none;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    pointer-events: none;
  }
  .pt-yt-thumb__play img {
    width: 40px;
    height: 44px;
  }
  .pt-yt-iframe-wrap {
    position: relative;
    width: 100%;
    padding-bottom: 56.25%;
    height: 0;
    border-radius: 12px;
    overflow: hidden;
  }
  .pt-yt-iframe-wrap iframe {
    position: absolute;
    top: 0; left: 0;
    width: 100%; height: 100%;
    border: none;
  }

  /* ══════════════════════════════════════
     SECTION 2 — BODY
  ══════════════════════════════════════ */
  .pt-body {
    padding-bottom: 100px;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .pt-body.pt-visible { opacity: 1; transform: translateY(0); }
  .pt-body__para {
    font-family: 'Roboto', sans-serif;
    font-size: 16px;
    font-weight: 400;
    color: #E2E2E2;
    line-height: 160%;
    margin-bottom: 14px;
  }
  .pt-body__para:last-child { margin-bottom: 0; }

  /* ══════════════════════════════════════
     SECTION 3 — OUR GUEST (1 guest)
  ══════════════════════════════════════ */
  .pt-guest {
    padding-bottom: 100px;
    text-align: center;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .pt-guest.pt-visible { opacity: 1; transform: translateY(0); }
  .pt-guest__title {
    font-family: 'Montserrat', sans-serif;
    font-size: 50px;
    font-weight: 700;
    color: #ffffff;
    margin-bottom: 60px;
  }
  .pt-guest__photo-bg {
    display: inline-block;
    width: 445px;
    height: 500px;
    background: #743FAC;
    border-radius: 12px;
    overflow: hidden;
  }
  .pt-guest__photo-bg img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: top center;
    display: block;
  }
  .pt-guest__name {
    font-family: 'Montserrat', sans-serif;
    font-size: 32px;
    font-weight: 700;
    color: #ffffff;
    margin-top: 24px;
  }

  /* ── TABLET (max 768px) ── */
  @media (max-width: 768px) {
    .pt-inner { padding-left: 32px; padding-right: 32px; }
    .pt-hero { padding-top: 32px; padding-bottom: 48px; }
    .pt-hero__grid { grid-template-columns: 1fr 1fr; gap: 24px; }
    .pt-hero__title { font-size: 24px; }
    .pt-hero__left { gap: 16px; }
    .pt-guest__title { font-size: 24px; margin-bottom: 24px; }
    .pt-guest__photo-bg { width: 260px; height: 300px; }
    .pt-guest__name { font-size: 24px; margin-top: 18px; }
    .pt-body__para { font-size: 14px; margin-bottom: 12px; }
    .pt-body { padding-bottom: 48px; }
    .pt-guest { padding-bottom: 48px; }
    .pt-yt-thumb__play img { width: 30px; height: 32px; }
  }

  /* ── MOBILE (max 480px) ── */
  @media (max-width: 480px) {
    .pt-inner { padding-left: 16px; padding-right: 16px; }
    .pt-hero { padding-top: 51px; padding-bottom: 30px; }
    .pt-hero__grid { grid-template-columns: 1fr; gap: 40px; }
    .pt-hero__left { gap: 30px; }
    .pt-hero__title { font-size: 30px; }
    .pt-body__para { font-size: 16px; margin-bottom: 10px; }
    .pt-guest__title { font-size: 30px; margin-bottom: 20px; }
    .pt-guest__photo-bg { width: 100%; height: 386px; }
    .pt-guest__name { font-size: 24px; text-align: left; margin-top: 14px; }
    .pt-body { padding-bottom: 30px; }
    .pt-guest { padding-bottom: 30px; }
    .pt-yt-thumb__play img { width: 30px; height: 32px; }
  }
`;

/* ─────────────────────────────────────────────
   FADE-UP HOOK
───────────────────────────────────────────── */
function useFadeUp(ref) {
  useEffect(() => {
    if (!ref.current) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("pt-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);
}

/* ─────────────────────────────────────────────
   YOUTUBE EMBED
───────────────────────────────────────────── */
const YT_VIDEO_ID = "REPLACE_EP54_VIDEO_ID";

function YouTubeEmbed() {
  const [playing, setPlaying] = useState(false);

  if (playing) {
    return (
      <div className="pt-yt-iframe-wrap">
        <iframe
          src={`https://www.youtube.com/embed/${YT_VIDEO_ID}?autoplay=1&rel=0`}
          title="EP 54 Pratik Gupta"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    );
  }

  return (
    <div className="pt-yt-thumb" onClick={() => setPlaying(true)} role="button" aria-label="Play video">
      <img src={ThumbImg} alt="EP 54 Pratik Gupta thumbnail" />
      <div className="pt-yt-thumb__play">
        <img src={PlayIcon} alt="Play" />
      </div>
    </div>
  );
}

/* ─────────────────────────────────────────────
   SECTIONS
───────────────────────────────────────────── */
function HeroSection() {
  const titleRef   = useRef(null);
  const spotifyRef = useRef(null);
  const rightRef   = useRef(null);

  useFadeUp(titleRef);
  useFadeUp(spotifyRef);
  useFadeUp(rightRef);

  return (
    <section className="pt-hero">
      <div className="pt-inner">
        <div className="pt-hero__grid">
          <div className="pt-hero__left">
            <h1 ref={titleRef} className="pt-hero__title">
              EP 54 | Decoding the Future of Urban Electric Mobility | Gensol EV | Pratik Gupta
            </h1>
            <div ref={spotifyRef} className="pt-hero__spotify">
              <iframe
                src="https://open.spotify.com/embed/episode/6IJFmcgNE1SucDWxr8ccwV?utm_source=generator&theme=0"
                allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                loading="lazy"
                title="EP 54 Spotify Player"
              />
            </div>
          </div>
          <div ref={rightRef} className="pt-hero__right">
            <YouTubeEmbed />
          </div>
        </div>
      </div>
    </section>
  );
}

function BodySection() {
  const ref = useRef(null);
  useFadeUp(ref);

  return (
    <section ref={ref} className="pt-body">
      <div className="pt-inner">
        <p className="pt-body__para">
          India's population is projected to surpass China's in both overall numbers and population density in the coming years. This growth is particularly concentrated in urban areas, which are facing significant challenges. Traffic congestion, increased road stress, road rage, and heightened demand for utilities and essential services are adversely affecting the quality of life for residents. To improve the lived experience of citizens, it is crucial to address the challenges of urban mobility. In this episode we have one of such innovative companies that are making strides in the urban mobility space – we met with Pratik Gupta, CEO of Gensol EV or Storm Motors who spoke about urban mobility.
        </p>
      </div>
    </section>
  );
}

function GuestSection() {
  const ref = useRef(null);
  useFadeUp(ref);

  return (
    <section ref={ref} className="pt-guest">
      <div className="pt-inner">
        <h2 className="pt-guest__title">Our Guest</h2>
        <div>
          <div className="pt-guest__photo-bg">
            <img src={GuestImg} alt="Pratik Gupta" />
          </div>
          <p className="pt-guest__name">Pratik Gupta</p>
        </div>
      </div>
    </section>
  );
}

/* ─────────────────────────────────────────────
   ROOT
───────────────────────────────────────────── */
export default function Ep54PratikGupta() {
  return (
    <>
      <style>{CSS}</style>
      <div className="pt-page">
        <HeroSection />
        <BodySection />
        <GuestSection />
      </div>
    </>
  );
}